<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <template v-slot:search-bar>
      <ion-toolbar>
        <ion-segment value="all" @ionChange="segmentChanged($event)">
          <ion-segment-button value="all">
            <ion-label>All</ion-label>
          </ion-segment-button>
          <ion-segment-button value="approved">
            <ion-label>Approved</ion-label>
          </ion-segment-button>
          <ion-segment-button value="rejected">
            <ion-label>Rejected</ion-label>
          </ion-segment-button>
          <ion-segment-button value="pending">
            <ion-label>Pending</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </template>
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-appeal :resources="resources"></list-appeal>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button>
        <ion-icon
          :ios="chevronBackCircleOutline"
          :md="chevronBackCircleOutline"
        ></ion-icon>
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button @click="setCreateModalState(true)">
          <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
        </ion-fab-button>
        <ion-fab-button @click="setFilterModalState(true)">
          <ion-icon :ios="funnelOutline" :md="funnelOutline"></ion-icon>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>

    <ion-modal
      :is-open="createModalState"
      @didDismiss="setCreateModalState(false)"
    >
      <base-modal
        title="Create Appeal"
        @closeModal="setCreateModalState(false)"
      >
        <create-appeal @closeModal="setCreateModalState(false)"></create-appeal>
      </base-modal>
    </ion-modal>

    <ion-modal
      :is-open="filterModalState"
      @didDismiss="setFilterModalState(false)"
    >
      <base-modal
        title="Filter Appeals"
        @closeModal="setFilterModalState(false)"
      >
        <filter-appeal
          @closeModal="setFilterModalState(false)"
        ></filter-appeal>
      </base-modal>
    </ion-modal>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import BaseModal from "../../Base/BaseModal";
import CreateAppeal from "../../Components/Appeal/CreateAppeal.vue";
import ListAppeal from "../../Components/Appeal/ListAppeal.vue";
import FilterAppeal from "../../Components/Appeal/FilterAppeal.vue"

import {
  IonGrid,
  IonRow,
  IonCol,
  IonFab,
  IonFabList,
  IonIcon,
  IonFabButton,
  IonModal,
  IonLabel,
  IonToolbar,
  IonSegment,
  IonSegmentButton,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import {
  funnelOutline,
  chevronBackCircleOutline,
  addOutline,
} from "ionicons/icons";

export default {
  components: {
    BaseLayout,
    BaseModal,
    ListAppeal,
    CreateAppeal,
    FilterAppeal,
    IonGrid,
    IonRow,
    IonCol,
    IonFab,
    IonFabList,
    IonIcon,
    IonFabButton,
    IonModal,
    IonLabel,
    IonToolbar,
    IonSegment,
    IonSegmentButton,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Applications",
      backLink: "dashboard",
      reloadable: true,
      createModalState: false,
      filterModalState: false,

      funnelOutline,
      chevronBackCircleOutline,
      addOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["appeal/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = false) {
      await this.$store.dispatch("appeal/resources", { refresh: refresh });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("appeal/resources", { refresh: true });
      if (event) {
        event.target.complete();
      }
    },
    setCreateModalState(state) {
      this.createModalState = state;
    },
    setFilterModalState(state) {
      this.filterModalState = state;
    },
    async segmentChanged(event) {
      await this.$store.dispatch("appeal/segment", event.target.value);
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
